/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import BigNumber from 'bignumber.js';
import { currencies, exchange } from '../../utilities/constants';
import { formatNumber } from '../../utilities/formatHelpers';
import { LTV, LTV_PERCENTAGES } from './constants';

export const calculateTotalInterestValue = (interestApr, loanLengthMonths, principle) => {
  const interestAprSafe = new BigNumber(interestApr);
  const totalInterest = interestAprSafe
    .dividedBy(100)
    .dividedBy(12)
    .multipliedBy(principle)
    .multipliedBy(loanLengthMonths)
    .toFixed(exchange.FIAT_VALUE, BigNumber.ROUND_UP);
  return totalInterest;
};

export const getLoanDetailsHelper = (loanDetails, rate) => {
  const { collateral_amount, collateral_currency, net_principal_amount, principal_currency } =
    loanDetails;

  const safeNetPrincipalAmount = new BigNumber(net_principal_amount).multipliedBy(
    currencies[principal_currency].conversion
  );

  const safeCollateralAmount = new BigNumber(collateral_amount).multipliedBy(
    currencies[collateral_currency].conversion
  );
  const safeCollateralAmountFiat = safeCollateralAmount.multipliedBy(rate);

  const displayedNetPrincipalAmount = formatNumber(
    safeNetPrincipalAmount,
    currencies[principal_currency].decimal
  );
  const displayedCollateralAmount = formatNumber(
    safeCollateralAmount,
    currencies[collateral_currency].decimal
  );
  const displayedCollateralAmountFiat = formatNumber(
    safeCollateralAmountFiat,
    currencies[principal_currency].decimal
  );

  const currentLTV = safeNetPrincipalAmount.dividedBy(safeCollateralAmountFiat).multipliedBy(100);
  const formattedCurrentLTV = currentLTV.toFormat(2);

  return {
    safeNetPrincipalAmount,
    displayedNetPrincipalAmount,
    safeCollateralAmount,
    displayedCollateralAmount,
    safeCollateralAmountFiat,
    displayedCollateralAmountFiat,
    currentLTV,
    formattedCurrentLTV,
  };
};

export const getRequiredFurtherCollateral = ({
  initialLTV,
  safeCollateralAmount,
  safeNetPrincipalAmount,
  rate,
}) => {
  const agreedLtvDecimal = initialLTV / 100;
  const totalRequiredCollateralValue = safeNetPrincipalAmount
    .dividedBy(agreedLtvDecimal)
    .toFixed(exchange.FIAT_VALUE, BigNumber.ROUND_HALF_CEIL);
  const totalRequiredCollateral = new BigNumber(totalRequiredCollateralValue)
    .dividedBy(rate)
    .toFixed(exchange.CRYPTO_VALUE, BigNumber.ROUND_HALF_CEIL);
  const furtherCollateral = new BigNumber(totalRequiredCollateral).minus(safeCollateralAmount);

  return furtherCollateral;
};

export const calculateClosestLtv = (ltv, startingIndex) => {
  let calculatedLTV = LTV.LTV_10;
  const dbLTVs = Object.values(LTV_PERCENTAGES);

  if (ltv < dbLTVs[startingIndex] || ltv === Infinity) {
    return LTV[`LTV_${dbLTVs[startingIndex]}`];
  }

  // eslint-disable-next-line no-plusplus
  for (let index = startingIndex; index < dbLTVs.length - 1; index++) {
    const lowDbLTV = dbLTVs[index];
    const highDbLTV = dbLTVs[index + 1];

    if (ltv > lowDbLTV && ltv < highDbLTV) {
      calculatedLTV = LTV[`LTV_${highDbLTV}`];
      return calculatedLTV;
    }
  }

  return calculatedLTV;
};
